import { apiSlice } from "./apiSlice";

/** @const {Object} Operations requests reuse application authentication. */
export const operationsApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getOperationsCalendar: builder.query({
      query: ({ from, to, localDate }) => ({
        url: "/api/operations/calendar/",
        params: {
          ...(from && { from }),
          ...(to && { to }),
          ...(localDate && { local_date: localDate }),
        },
        cache: "no-store",
      }),
      providesTags: ["OperationsOverview"],
      keepUnusedDataFor: 0,
    }),
    getOperationsOverview: builder.query({
      query: ({ section, offset, localDate, scope, due }) => ({
        url: "/api/operations/control-centre/",
        params: {
          ...(section && { section }),
          ...(offset && { offset }),
          ...(localDate && { local_date: localDate }),
          ...(scope && { scope }),
          ...(due && { due }),
        },
        cache: "no-store",
      }),
      providesTags: ["OperationsOverview"],
      keepUnusedDataFor: 0,
    }),
    getOperationsNotes: builder.query({
      query: ({ offset, dueOnly = false, overdueOnly = false }) => ({
        url: "/api/operations/tasks/",
        params: {
          offset,
          ...(overdueOnly && { overdue_only: "1" }),
          ...(dueOnly && !overdueOnly && { due_only: "1" }),
        },
        cache: "no-store",
      }),
    }),
    getOperationsNoteTargets: builder.query({
      query: search => ({ url: "/api/operations/tasks/", params: { search } }),
    }),
    getOperationsShipmentPurchaseOrders: builder.query({
      query: shipmentId => ({ url: "/api/operations/tasks/", params: { shipment_id: shipmentId } }),
    }),
    createOperationsNote: builder.mutation({
      query: body => ({ url: "/api_chat/note/", method: "POST", body }),
      invalidatesTags: ["OperationsOverview", "consignmentList", "filteredConsignmentList"],
    }),
    updateOperationsNote: builder.mutation({
      query: ({ id, body }) => ({ url: `/api_chat/note/${id}/`, method: "PATCH", body }),
      invalidatesTags: ["OperationsOverview", "consignmentList", "filteredConsignmentList"],
    }),
    deleteOperationsNote: builder.mutation({
      query: id => ({ url: `/api_chat/note/${id}/`, method: "DELETE" }),
      invalidatesTags: ["OperationsOverview", "consignmentList", "filteredConsignmentList"],
    }),
    dismissOperationsWelcome: builder.mutation({
      query: () => ({ url: "/api/operations/control-centre/", method: "PATCH", body: {} }),
    }),
  }),
});

export const {
  useGetOperationsCalendarQuery,
  useGetOperationsOverviewQuery,
  useLazyGetOperationsNotesQuery,
  useGetOperationsNoteTargetsQuery,
  useGetOperationsShipmentPurchaseOrdersQuery,
  useCreateOperationsNoteMutation,
  useUpdateOperationsNoteMutation,
  useDeleteOperationsNoteMutation,
  useDismissOperationsWelcomeMutation,
} =
  operationsApiSlice;
